import "../Participant/ParticipantShop.css";

import { useEffect, useState } from "react";
import FundraiserHeader from "../../components/ImprovedShopPage/FundraiserHeader";
import Shop from "../../components/ImprovedShopPage/Shop";
import { FundraiserProvider } from "../ImprovedShopPage/FundraiserContext";
import "../ImprovedShopPage/styles/custom.css";
import { createTheme, ThemeProvider } from "@mui/material";
import Donation from "../../components/ImprovedShopPage/Donation";
import { ImprovedParticipantShop } from "../../Interfaces/FundraiserRole";
import config from "../../config";
import { useParams } from "react-router-dom";
import calculateTimeLeft from "../../components/ImprovedShopPage/CalculateTimeLeft";
import FundraiserExpired from "../../components/ImprovedShopPage/ShopTimeExpired";
import { static_participant_shop_data } from "./StaticShopData/StaticShopData";

const theme = createTheme({
  palette: {
    mode: "light",
    primary: {
      main: "#0C5D53",
      // light: primaryColor[300],
      // dark: primaryColor[700],
      contrastText: "#fff",
    },
  },
  colorSchemes: {
    light: {
      palette: {
        primary: {
          main: "#0C5D53",
          // light: primaryColor[300],
          // dark: primaryColor[700],
          contrastText: "#fff",
        },
      },
    },
    dark: {
      palette: {
        primary: {
          main: "#0C5D53",
          // light: primaryColor[300],
          // dark: primaryColor[700],
          contrastText: "#fff",
        },
      },
    },
  },
});

const SampleStaticShop = () => {
  const [participantShop, setParticipantShop] =
    useState<ImprovedParticipantShop>();
  const [timeLeft, setTimeLeft] = useState({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0,
  });

  const isTimeOver = (): boolean => {
    return (
      timeLeft.days === 0 &&
      timeLeft.hours === 0 &&
      timeLeft.minutes === 0 &&
      timeLeft.seconds === 0
    );
  };

  useEffect(() => {
    setParticipantShop(static_participant_shop_data);
    document.title = "Participant Shop";
  }, []);

  useEffect(() => {
    if (!participantShop?.fundraiser.end_date) return;

    const timer = setInterval(() => {
      setTimeLeft(calculateTimeLeft(participantShop.fundraiser.end_date));
    }, 1000);

    return () => clearInterval(timer);
  }, [participantShop?.fundraiser.end_date]);
  if (!participantShop) return null;

  return (
    <div className="main">
      <ThemeProvider theme={theme}>
        <FundraiserProvider>
          <>
            <FundraiserHeader
              participantShop={participantShop}
              timeLeft={timeLeft}
              isFromSamplePage={true}
            />
            {isTimeOver() ? (
              <FundraiserExpired />
            ) : (
              <>
                <Shop
                  participantShop={participantShop}
                  isFromSamplePage={true}
                />
                <Donation
                  participantShop={participantShop}
                  isFromSamplePage={true}
                />
              </>
            )}
          </>
        </FundraiserProvider>
      </ThemeProvider>
    </div>
  );
};

export default SampleStaticShop;
